module.exports = "<p>\r\n  achievements works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/achievements/achievements.component.html
// module id = ../../../../../src/app/content-page/achievements/achievements.component.html
// module chunks = main